global.checkLongTitles = function() {
	var titles = document.querySelectorAll('.report-page:not(.report-page--imported) h1.page-title');

	Array.prototype.forEach.call(titles, function (title) {
		var words = title.innerText.split(' ');

		//Check long words
		for (var i in words) {
			if (words[i].length > 15) {
				title.classList.add('title--long');
			}
		}

		//Check long title
		if (title.innerText.length > 40) {
			title.classList.add('title--long');
		}
	});
};

global.checkLongTitles();
